import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, makeStyles, Typography, useTheme } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around'
    },
    imageList: {
        width: '100%',
        height: '100%'
    },
    titleDescription: {
        color: theme.palette.text.secondary,
        paddingTop: theme.spacing(0.5)
    },
    content: {
        paddingTop: 0
    },
    uploadIcon: {
        marginRight: 12,
        marginLeft: -4
    },
    title: {
        color: 'white'
    },
    titleBar: {
        background: 'black'
    }
}))

function SelectCompanies({ visitorSessionId, open, onClose, ...rest }) {
    const classes = useStyles()
    const [companies, setCompanies] = useState([])
    const [excludedCompanyIds, setExcludedCompanyIds] = useState([])

    useEffect(() => {
        if (open) {
            fetchCompanies()
        }
    }, [open])

    const fetchCompanies = () => {
        axios
            .get(process.env.MIX_API_URL + `/terms/companies/${getVisitorCookie()}`)
            .then(({ data, ...res }) => {
                setCompanies(data.companies)
                setExcludedCompanyIds(data.excludedCompanies)
            })
            .catch(err => {})
    }

    const onSave = () => {
        axios
            .post(process.env.MIX_API_URL + `/terms/companies/${getVisitorCookie()}/save`, {
                companies: excludedCompanyIds
            })
            .then(({ data, ...res }) => {
                onClose()
            })
            .catch(err => {
                onClose()
            })
    }

    const isCompanyExcluded = id => {
        return excludedCompanyIds.includes(id)
    }

    const getSelectedCompaniesTable = () => {
        if (!companies) return null
        const table = []
        const elements = companies.map((company, index) => {
            return (
                <tr key={index}>
                    <td>
                        <Button
                            onClick={() => {
                                isCompanyExcluded(company.id)
                                    ? setExcludedCompanyIds(excludedCompanyIds.filter(id => id !== company.id))
                                    : setExcludedCompanyIds([...excludedCompanyIds, company.id])

                                console.log('click')
                            }}
                        >
                            {isCompanyExcluded(company.id) ? 'Anmäl' : 'Avanmäla'}
                        </Button>
                    </td>
                    <td>{company.name}</td>
                </tr>
            )
        })
        return elements
    }

    const getVisitorCookie = () => {
        const name = 'vc'
        const value = '; ' + document.cookie
        const parts = value.split('; ' + name + '=')
        if (parts.length === 2)
            return parts
                .pop()
                .split(';')
                .shift()
    }

    return (
        <>
            {
                <Dialog onClose={onClose} open={open} scroll={'paper'} fullWidth={true} maxWidth={false} style={{ height: '100vh' }}>
                    <DialogTitle disableTypography>Samarbetspartners</DialogTitle>
                    <DialogContent className={classes.content} dividers={true}>
                        <table>{getSelectedCompaniesTable()}</table>
                    </DialogContent>
                    <DialogActions key={'dialogClose'}>
                        <Button onClick={onSave} color="primary" autoFocus key={'close'}>
                            Save
                        </Button>
                        <Button onClick={onClose} color="primary" autoFocus key={'close'}>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            }
        </>
    )
}

export default SelectCompanies
